import Vue from 'vue'
import Router from 'vue-router'
import Vuex from 'vuex';


import store from '../store'
import middlewarePipeline from './middlewares/middlewarePipeline'
import axios from 'axios'
import auth from './middlewares/auth'
import guest from './middlewares/guest'
import authsuntech from './middlewares/authsuntech'



Vue.use(Router);
Vue.use(axios);
Vue.use(Vuex);

/***************** components imports  ************************/
import Blank from '../components/Blank'
import Home from '../components/Home';
import Categorie from '../components/Categorie';
import Quartier from '../components/Quartier';
import Pharmacie from '../components/Pharmacie';
import Blog from '../components/Blog';
import Assureur from '../components/Assureur';
import Tier from '../components/Tiers';
import TierAssureur from '../components/TiersAssureur';
import RoleUser from '../components/RoleUser';
import Departement from '../components/Departement';
import FormePharmacetique from '../components/FormePharmacetique';
import TiersType from '../components/TiersTypes';
import Useradmin from '../components/Useradmin';
import Role from '../components/Role';
import Userpharmacie from '../components/Userpharmacie';
import Login from '../components/Login';
import Balance from '../components/Balance';
import AskPayout from '../components/AskPayout';
import Paiement from '../components/Paiement';
import BalanceStorie from '../components/BalanceStorie';
import Produit from '../components/Produit';
import PharmaProduit from '../components/PharmaProduit';
import NewProduit from '../components/NewProduit';
import Historique from '../components/Historique';
import UploadExcel from '../components/UploadExcel';
import ProduitPharmaAttribution from '../components/ProduitPharmaAttribution';
import PrecommandePharma from '../components/PrecommandePharma';
import PrecommandeAdmin from '../components/PrecommandeAdmin';
import Profil from '../components/Profil';
import Permission from '../components/Permission';
import UsersAllAdmin from '../components/UsersAllAdmin';

Vue.component('Blank', Blank);
Vue.component('Home', Home);
Vue.component('Categorie', Categorie);
Vue.component('Quartier', Quartier);
Vue.component('Pharmacie', Pharmacie);
Vue.component('Blog', Blog);
Vue.component('Profil', Profil);
Vue.component('Assureur', Assureur);
Vue.component('Tier', Tier);
Vue.component('TierAssureur', TierAssureur);
Vue.component('RoleUser', RoleUser);
Vue.component('Departement', Departement);
Vue.component('FormePharmacetique', FormePharmacetique);
Vue.component('TierType', TiersType);
Vue.component('Useradmin', Useradmin);
Vue.component('Userpharmacie', Userpharmacie);
Vue.component('Login', Login);
Vue.component('Balance', Balance);
Vue.component('Role', Role);
Vue.component('AskPayout', AskPayout);
Vue.component('Paiement', Paiement);
Vue.component('BalanceStorie', BalanceStorie);
Vue.component('Produit', Produit);
Vue.component('PharmaProduit', PharmaProduit);
Vue.component('NewProduit', NewProduit);
Vue.component('Historique', Historique);
Vue.component('UploadExcel', UploadExcel);
Vue.component('ProduitPharmaAttribution', ProduitPharmaAttribution);
Vue.component('PrecommandePharma', PrecommandePharma);
Vue.component('PrecommandeAdmin', PrecommandeAdmin);
Vue.component('Permission', Permission);
Vue.component('UsersAllAdmin', UsersAllAdmin);

const router = new Router({
    routes: [

        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                middleware: [
                    auth
                ]
            }
        },{
            path: '*',
            name: 'home',
            component: Home,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/categories',
            name: 'categories',
            component: Categorie,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/quartiers',
            name: 'quartiers',
            component: Quartier,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/tiers_type',
            name: 'tiers_types',
            component: TiersType,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/roles',
            name: 'roles',
            component: Role,
            meta: {
                middleware: [
                    auth,
                    authsuntech

                ]
            }
        },
        {
            path: '/tiers_assurance/:id',
            name: 'tiersassurance',
            component: TierAssureur,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/roles_users/:id',
            name: 'roleuser',
            component: RoleUser,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/pharmacies',
            name: 'pharmacies',
            component: Pharmacie,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/blogs',
            name: 'blogs',
            component: Blog,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/assureurs',
            name: 'assureurs',
            component: Assureur,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/tiers',
            name: 'tiers',
            component: Tier,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/askPayout',
            name: 'askPayout',
            component: AskPayout,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/paiement',
            name: 'paiement',
            component: Paiement,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/balance_storie',
            name: 'balance_storie',
            component: BalanceStorie,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/departements',
            name: 'departements',
            component: Departement,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },

        {
            path: '/formes_pharmacetique',
            name: 'formephamarcetique',
            component: FormePharmacetique,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/usersadmins',
            name: 'usersadmins',
            component: UsersAllAdmin,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/profil',
            name: 'profil',
            component: Profil,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/users_pharmacie',
            name: 'userspharmacie',
            component: Userpharmacie,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/produits',
            name: 'produits',
            component: Produit,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: '/balance',
            name: 'balance',
            component: Balance,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/pharmaproduits',
            name: 'pharmaproduits',
            component: PharmaProduit,
            meta: {
                middleware: [
                    auth
                ]
            }
        },
        {
            path: '/newproduit',
            name: 'newproduit',
            component: NewProduit,
            meta: {
                middleware: [
                    auth
                ]
            }
        },{
            path: '/updateproduit/:id',
            name: 'updateproduit',
            component: NewProduit,
            meta: {
                middleware: [
                    auth
                ]
            }
        },{
            path: '/uploadexcel',
            name: 'uploadexcel',
            component: UploadExcel,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },{
            path: '/historique/:id/:prod',
            name: 'historique',
            component: Historique,
            meta: {
                middleware: [
                    auth
                ]
            }
        },{
            path: '/attribution',
            name: 'produitpharmaattribution',
            component: ProduitPharmaAttribution,
            meta: {
                middleware: [
                    auth
                ]
            }
        },{
            path: '/pharmacie_commande',
            name: 'precommandepharma',
            component: PrecommandePharma,
            meta: {
                middleware: [
                    auth
                ]
            }
        },{
            path: '/permission',
            name: 'permission',
            component: Permission,
            meta: {
                middleware: [
                    auth
                ]
            }
        },{
            path: '/admin_commande',
            name: 'precommandeadmin',
            component: PrecommandeAdmin,
            meta: {
                middleware: [
                    auth,
                    authsuntech
                ]
            }
        },
        {
            path: "/login",
            name: "login",
            component: Login,
            meta: {
                middleware: [
                    guest
                ]
            }
        },


    ]
});

router.beforeEach((to, from, next) => {
    if (!to.meta.middleware) {
        return next()
    }
    const middleware = to.meta.middleware;

    const context = {
        to,
        from,
        next,
        store
    };
    console.log("middle : "+middleware);
    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })

});

export default router
